export class TextHtmlValueConverter {
	toView(text) {
		return text ? text.replace(/(?:\r\n|\r|\n)/g, '<br>') : null;
	}
}
